/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function FooterMenuDrop
 */

class FooterMenuDrop {
  constructor(self) {
    this.menu = self;
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let menu = this.menu;

    if (!menu.classList.contains('active')) {
      menu.classList.add('active');

    } else {
      menu.classList.remove('active');
    }
  }
}

let menus = document.querySelectorAll('.thb-menudrop');
menus.forEach((menu) => {
  new FooterMenuDrop(menu);
});